import { BaseDto } from '../base.dto';
import { GiftCardPhysicalCardDto } from './giftCardPhysicalCard.dto';

export class GiftCardAddressDto extends BaseDto {
  recipientName?: string;
  buildingName?: string;
  buildingNumber?: string;
  street: string;
  city: string;
  country?: string;
  postCode?: string;
  giftCard: GiftCardPhysicalCardDto;
  countryCode?: string;
}
